import type { RouteRecordRaw } from 'vue-router'

import { DEFAULT_LAYOUT } from '@/router/constant'

const receivedMessage: RouteRecordRaw = {
  path: '/received-message',
  name: 'ReceivdMessage',
  component: DEFAULT_LAYOUT,

  children: [],
}

export default receivedMessage
